import { categories, site } from '@/mocks/manhwa';

function scrollToSection(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export default function Hero() {
  return (
    <section className="relative flex min-h-[86vh] items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20illustration%20of%20diverse%20manhwa%20characters%20and%20comic%20panels%20floating%20in%20warm%20cream%20and%20coral%20tones%2C%20books%20and%20open%20pages%2C%20playful%20editorial%20magazine%20composition%2C%20artistic%20flat%20illustration%20style%2C%20rich%20texture%2C%20inviting%20cozy%20atmosphere&width=1600&height=900&seq=hero-manhwa&orientation=landscape"
          alt="好看的韩漫推荐书单背景插画"
          title="好看的韩漫推荐 精选必看书单"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/40 to-background-950/80" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-3xl">
          <p className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
            <i className="ri-bookmark-line" /> {site.brand} · 好看的韩漫推荐
          </p>
          <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
            好看的韩漫推荐
            <span className="mt-2 block text-accent-300">高分人气 × 冷门宝藏 都在这</span>
          </h1>
          <p className="mt-6 max-w-xl text-base leading-7 text-background-200 md:text-lg">
            一份持续更新的韩漫推荐书单，从高分人气到冷门宝藏全收录。按题材分类整理必看佳作，帮你快速找到合口味的作品，追更不迷路。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => scrollToSection('featured')}
              className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              开始逛书单
            </button>
            <button
              type="button"
              onClick={() => scrollToSection('genres')}
              className="whitespace-nowrap rounded-full border border-background-50/40 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/15"
            >
              查看题材分类
            </button>
          </div>

          <div className="mt-10 flex flex-wrap gap-2">
            {categories.map((c) => (
              <button
                key={c.id}
                type="button"
                onClick={() => scrollToSection('genres')}
                className="whitespace-nowrap rounded-full bg-background-50/10 px-3.5 py-1.5 text-xs text-background-100 ring-1 ring-background-50/25 transition-colors hover:bg-accent-500 hover:text-background-950 hover:ring-accent-500"
              >
                {c.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 text-background-50/70 animate-bounce">
        <i className="ri-arrow-down-line text-xl" />
      </div>
    </section>
  );
}